/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import { Grid } from "@mui/material";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import ViewCard from "components/ViewCard/ViewCard";
import CustomText from "components/customtext/customtext";
import Height from "components/height/height";
import { useMaterialUIController } from "context";
import PageTitle from "examples/PageTitle/PageTitle";
import DataTable from "examples/Tables/DataTable";
import PaymentLayout from "layouts/authentication/components/PaymentLayout/PaymentLayout";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  createGatewayUrlByID,
  getOrderByID,
  updatePaymentStatusByID,
} from "utils/api";
import { showResMsg } from "utils/generic";
import "../makePayment/makePayment.scss";

function MakePayment() {
  const { id } = useParams();
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [values, setValues] = React.useState({
    orderNumber: "",
    orderDate: "",
    shipmentType: "",
    paymentType: "",
    senderCity: "",
    receiverCity: "",
    distance: "",
    totalCharges: "",
  });

  const [values1, setValues1] = React.useState({
    orderNumber: "",
    orderDate: "",
    shipmentType: "",
    paymentType: "",
    senderCity: "",
    receiverCity: "",
    distance: "",
    totalCharges: "",
  });
  const [customer, setCustomer] = React.useState({});

  useEffect(() => {
    if (id !== undefined) {
      const urlParams = new URLSearchParams(window.location.search);
      const paramValue1 = urlParams.get("Failed");
      if (paramValue1 === "true") {
        updatePaymentStatus();
      }
      fetchOrder();
    }
  }, []);

  const updatePaymentStatus = async () => {
    updatePaymentStatusByID(
      { id: id },
      (data) => {
        if (data.Result_Status) {
          showResMsg(data.Result_Message, 1000, false);
          setTimeout(() => {
            window.location.href = `/makePayment/${id}`;
          }, 2000);
        }
      },
      dispatch
    );
  };

  const fetchOrder = async () => {
    getOrderByID(
      { id: id },
      (data) => {
        if (data.Result_Output.length > 0) {
          setValues(data.Result_Output[0]);
          setRows(data.Result_Output);
        }
      },
      dispatch
    );
  };

  const generateUrl = async () => {
    values.gatewayUserID = customer.gatewayUserID;
    values.amount = values.totalCharges;
    createGatewayUrlByID(
      values,
      (data) => {
        if (data.Result_Status) {
          navigate(data.response.Result_Output.url);
        }
      },
      dispatch
    );
  };

  const screenName = "Order Information";
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  return (
    <PaymentLayout>
      <Height val={30} />
      <Card>
        <PageTitle screenName={screenName} />
        <Grid container px={2}>
          <Grid
            item
            xs={12}
            md={3}
            lg={12}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            {/* <Link to={"/orders"} >
              <MDButton color="success">Make Payment</MDButton>
            </Link> */}
            <Grid item xs={3}>
              <Card sx={{ backgroundColor: "aliceblue" }}>
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    px={2}
                    pt={2}
                  >
                    <CustomText type="b" size={17} style={{ color: "black" }}>
                      {values1.companyName}
                      <br />
                    </CustomText>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    px={4.5}
                    pb={2}
                  >
                    {" "}
                    <CustomText type="p" size={17} style={{ color: "black" }}>
                      {values1.companyStreetAddress}
                      {values1.companyCity}
                    </CustomText>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          px={2}
          mt={2}
          columnSpacing={2}
          justifyContent={"space-between"}
        >
          <Grid item xs={4.5}>
            <Card sx={{ backgroundColor: "aliceblue" }}>
              <Grid container>
                <Grid
                  item
                  xs={6}
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                  pl={5}
                  pt={2}
                >
                  <CustomText type="p" size={17} style={{ color: "black" }}>
                    Order Number:
                  </CustomText>
                </Grid>
                <Grid item xs={6} style={{ marginBottom: "2px" }} pl={5} pt={2}>
                  <CustomText type="b" size={16} style={{ color: "black" }}>
                    {values.orderNumber}
                  </CustomText>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                  pl={5}
                  pb={2}
                >
                  <CustomText type="p" size={17} style={{ color: "black" }}>
                    Order Date:
                  </CustomText>
                </Grid>
                <Grid item xs={6} style={{ marginBottom: "2px" }} pl={5} pb={2}>
                  <CustomText type="b" size={16} style={{ color: "black" }}>
                    {values.orderDate}
                  </CustomText>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          <Grid item xs={4.5}>
            <Card sx={{ backgroundColor: "aliceblue" }}>
              <Grid container>
                <Grid
                  item
                  xs={6}
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                  pl={5}
                  pt={2}
                >
                  <CustomText type="p" size={17} style={{ color: "black" }}>
                    Consignment Type:
                  </CustomText>
                </Grid>
                <Grid item xs={6} style={{ marginBottom: "2px" }} pl={5} pt={2}>
                  <CustomText type="b" size={16} style={{ color: "black" }}>
                    {values.shipmentType}{" "}
                  </CustomText>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                  pl={5}
                  pb={2}
                >
                  <CustomText type="p" size={17} style={{ color: "black" }}>
                    Payment Type:
                  </CustomText>
                </Grid>
                <Grid item xs={6} style={{ marginBottom: "2px" }} pl={5} pb={2}>
                  <CustomText type="b" size={16} style={{ color: "black" }}>
                    {values.paymentType}
                  </CustomText>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>

        <Grid
          container
          px={2}
          mt={2}
          columnSpacing={2}
          justifyContent={"space-between"}
        >
          <Grid item xs={4.5} pl={5}>
            <Card sx={{ backgroundColor: "aliceblue" }}>
              <Grid
                item
                xs={8}
                pl={5}
                style={{ display: "flex", alignItems: "center" }}
                pt={3}
              >
                <CustomText type="b" size={17} style={{ color: "black" }}>
                  Sender Address:
                </CustomText>
              </Grid>
              <Grid
                item
                xs={12}
                pl={5}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText type="p" size={17} style={{ color: "black" }}>
                  {values.senderName}
                </CustomText>
              </Grid>
              <Grid
                item
                xs={12}
                pl={5}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText type="p" size={17} style={{ color: "black" }}>
                  {values.senderStreetAddress}
                </CustomText>
              </Grid>
              <Grid
                item
                xs={12}
                pl={5}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText type="p" size={17} style={{ color: "black" }}>
                  {values.senderCity} , {values.senderZipCode}
                </CustomText>
              </Grid>
              <Grid
                item
                xs={12}
                pl={5}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText
                  type="p"
                  size={17}
                  style={{ color: "black" }}
                ></CustomText>
              </Grid>
              <Grid
                item
                xs={12}
                pl={5}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText type="p" size={17} style={{ color: "black" }}>
                  {values.senderContactNumber}
                </CustomText>
              </Grid>

              <Height val={28} />
            </Card>
          </Grid>
          <Grid item xs={3}>
            <ViewCard>
              <Grid container>
                <Grid
                  item
                  xs={8}
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                  pl={5}
                  pt={2}
                >
                  <CustomText type="p" size={17}>
                    Total Charges:
                  </CustomText>
                </Grid>
                <Grid item xs={4} style={{ marginBottom: "2px" }} pl={3} pt={2}>
                  <CustomText type="b" size={16}>
                    {values.totalCharges}
                  </CustomText>
                </Grid>

                <Grid
                  item
                  xs={8}
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                  pl={5}
                >
                  <CustomText type="p" size={17}>
                    Linehaul Charges:
                  </CustomText>
                </Grid>
                <Grid item xs={4} style={{ marginBottom: "2px" }} pl={3}>
                  <CustomText type="b" size={16}>
                    {values.variableCharges}
                  </CustomText>
                </Grid>
                {values.shipmentType === "Sender Location Pickup" && (
                  <>
                    <Grid
                      item
                      xs={8}
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                      }}
                      pl={5}
                      pb={2}
                    >
                      <CustomText type="p" size={17}>
                        Pickup Charges:
                      </CustomText>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      style={{ marginBottom: "2px" }}
                      pl={3}
                      pb={2}
                    >
                      <CustomText type="b" size={16}>
                        {values.fixedCharges}
                      </CustomText>
                    </Grid>
                  </>
                )}
              </Grid>
            </ViewCard>
          </Grid>

          <Grid item xs={4.5}>
            <Card sx={{ backgroundColor: "aliceblue" }}>
              <Grid
                item
                xs={8}
                pl={5}
                pt={3}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText type="b" size={17} style={{ color: "black" }}>
                  Receiver Address:
                </CustomText>
              </Grid>
              <Grid
                item
                xs={12}
                pl={5}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText type="p" size={17} style={{ color: "black" }}>
                  {values.receiverName}
                </CustomText>
              </Grid>
              <Grid
                item
                xs={12}
                pl={5}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText type="p" size={17} style={{ color: "black" }}>
                  {values.receiverStreetAddress}
                  <br /> {values.receiverCity} , {values.receiverZipCode}
                </CustomText>
              </Grid>
              <Grid
                item
                xs={12}
                pl={5}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText
                  type="p"
                  size={17}
                  style={{ color: "black" }}
                ></CustomText>
              </Grid>
              <Grid
                item
                xs={12}
                pl={5}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <CustomText type="p" size={17} style={{ color: "black" }}>
                  {values.receiverContactNumber}
                </CustomText>
              </Grid>
              <Height val={28} />
            </Card>
          </Grid>
        </Grid>
        <MDBox px={2} mt={-2}>
          <DataTable
            Header={false}
            screenName={false}
            addNew={false}
            //   link="/addDocument"
            table={{
              filterable: true,
              rows,
              columns: [
                {
                  Header: "No Of Items",
                  accessor: "numberOfItems",
                  align: "center",
                },
                {
                  Header: "Cargo Type",
                  accessor: "cargoType",
                  align: "center",
                },
                {
                  Header: "Description",
                  accessor: "description",
                  align: "left",
                },
                {
                  Header: "Weight (Kg)",
                  accessor: "weightInKg",
                  align: "center",
                },
                {
                  Header: "Length (mm)",
                  accessor: "lengthInMm",
                  align: "center",
                },

                {
                  Header: "Breadth (mm)",
                  accessor: "breadthInMm",
                  align: "center",
                },
                {
                  Header: "Height (mm)",
                  accessor: "heightInMm",
                  align: "center",
                },
              ],
            }}
            // rows={values.roles}
            canSearch={false}
            isSorted={true}
            entriesPerPage={false}
            showTotalEntries={false}
            pagination={true}
            noEndBorder
          />
        </MDBox>
      </Card>
      <Grid
        container
        mt={2}
        columnSpacing={4}
        alignItems="center"
        display="flex"
        justifyContent="center"
      >
        {/* {values.paymentStatus !== "Successful" &&
          <Grid item xs={12} md={4} spacing={2} lg={2}>

            <Link to={"/users"}>
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                // color="danger"
                style={{backgroundColor:'red',color:'white'}}
                fullWidth
              >
                Cancel Order
              </MDButton>
            </Link>
          </Grid>
} */}
        {values.paymentStatus !== "Successful" && (
          <Grid item xs={12} md={4} spacing={2} lg={2}>
            <MDButton
              onClick={generateUrl}
              rel="noreferrer"
              variant="gradient"
              color="success"
              fullWidth
            >
              {values.paymentStatus === "Failed" ? (
                <>Re-Payment</>
              ) : (
                <>Make Payment</>
              )}
            </MDButton>
          </Grid>
        )}
      </Grid>
    </PaymentLayout>
  );
}

export default MakePayment;
